import { Divider, Heading, TextArea } from 'component-library';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { type AddContainers } from '@sr/types';
import { InputField } from 'component-library/components/Input/Text/InputField';
import { FormSection } from './styles';
import { AddContainersFileUpload } from './AddContainersFileUpload';

export const OrderDetailsForm = () => {
  const { t } = useTranslation();
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext<AddContainers>();

  const email = useWatch({
    control,
    name: 'orderDetails.contactInformation.email',
  });

  const containers = useWatch({
    control,
    name: 'containers',
  });

  const additionalRecipient = useWatch({
    control,
    name: 'orderDetails.additionalRecipient',
  });

  // Trigger validation on email field when it changes, if there are existing errors
  useEffect(() => {
    if (errors.orderDetails?.contactInformation?.email) {
      void trigger('orderDetails.contactInformation.email');
    }
  }, [email, trigger, errors.orderDetails]);

  // Trigger validation on email field when it changes, if there are existing errors
  useEffect(() => {
    if (errors.orderDetails?.additionalRecipient) {
      void trigger('orderDetails.additionalRecipient');
    }
  }, [additionalRecipient, trigger, errors.orderDetails]);

  return (
    <>
      <Heading as="h2" variant="small">
        {t('add.container.step2.step-title')}
      </Heading>
      {containers.length > 0 && (
        <>
          <FormSection>
            <Controller
              name={'orderDetails.contactInformation.name'}
              control={control}
              render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => {
                return (
                  <InputField
                    onBlur={onBlur}
                    label={t('add.container.step2.order-details.contact-information.name.label')}
                    placeholder={t(
                      'add.container.step2.order-details.contact-information.name.placeholder',
                    )}
                    defaultValue={value}
                    onChange={onChange}
                    errorMessage={error?.message ? t(error.message) : undefined}
                  />
                );
              }}
            />

            <Controller
              name={'orderDetails.contactInformation.phone'}
              control={control}
              render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                <InputField
                  onBlur={onBlur}
                  label={t('add.container.step2.order-details.contact-information.phone.label')}
                  placeholder={t(
                    'add.container.step2.order-details.contact-information.phone.placeholder',
                  )}
                  defaultValue={value}
                  onChange={onChange}
                  errorMessage={error?.message ? t(error.message) : undefined}
                />
              )}
            />

            <Controller
              name={'orderDetails.contactInformation.email'}
              control={control}
              render={({ field: { onChange, value, onBlur }, fieldState: { error } }) => (
                <InputField
                  onBlur={onBlur}
                  label={t('add.container.step2.order-details.contact-information.email.label')}
                  placeholder={t(
                    'add.container.step2.order-details.contact-information.email.placeholder',
                  )}
                  defaultValue={value}
                  onChange={onChange}
                  errorMessage={error?.message ? t(error.message) : undefined}
                />
              )}
            />
          </FormSection>
          <Divider mb="mediumLow" />
        </>
      )}

      <FormSection>
        <Controller
          name={'orderDetails.comment'}
          control={control}
          render={({ field: { onChange, value } }) => (
            <TextArea
              characterLimit={200}
              label={t('add.container.step2.order-details.comment.label')}
              defaultValue={value}
              onChange={onChange}
              description={t('add.container.step2.order-details.comment.description')}
            />
          )}
        />

        <AddContainersFileUpload />
      </FormSection>
    </>
  );
};
